import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  gradient?: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
  gradient,
}) => {
  return (
    <Card
      sx={{
        height: '100%',
        background: '#ffffff',
        borderRadius: 3,
        p: 0.125,
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        border: '2px solid transparent',
        backgroundImage: gradient
          ? `linear-gradient(white, white), ${gradient}`
          : 'linear-gradient(white, white), linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        '&:hover': {
          transform: 'translateY(-8px) scale(1.02)',
          boxShadow: '0px 20px 60px rgba(99, 102, 241, 0.2)',
          '& .feature-icon': {
            transform: 'scale(1.1) rotate(5deg)',
          },
        },
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box
          className="feature-icon"
          sx={{
            width: 64,
            height: 64,
            borderRadius: 2.5,
            background: gradient || 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
            transition: 'transform 0.3s ease',
            color: '#ffffff',
            fontSize: '2rem',
            boxShadow: '0px 8px 24px rgba(99, 102, 241, 0.3)',
          }}
        >
          {icon}
        </Box>
        <Typography variant="h6" fontWeight={700} gutterBottom color="text.primary">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" lineHeight={1.7}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};
